import { SidebarMenuFooter } from 'app/domains/common-ui';
import { UserAccountMenu } from 'app/domains/users';
export function Footer() {
    return (<SidebarMenuFooter>
      <UserAccountMenu />
    </SidebarMenuFooter>);
}
